﻿export interface IWatrMileageTripDetail {
    tripDate: string,
    tripReason: string,
    tripMiles: number,
    reimbursementRate: number,
    reimbursementAmount: number
}